<div class="container">
  <h1>{{ 'errors.pageNotFound_title' | cxTranslate }}</h1>
</div>
